module.exports = __webpack_public_path__ + "img/sms-logo.b8515f99.svg";